import { PrimaryColors, BrandColors, TextColors, BackgroundColors, ErrorColors, WarningColors, InformationColors, AbsoluteWhiteColors, NegativeColors } from '@picsart/design-system/foundation/colors';

const colors = {
  accents: {
    primary: PrimaryColors,
    secondary: BrandColors,
  },
  texts: {
    ...TextColors,
    negative: NegativeColors.text.default,
  },
  backgrounds: BackgroundColors,
  statuses: {
    error: ErrorColors,
    warning: WarningColors,
    information: InformationColors,
  },
  absolutes: {
    white: AbsoluteWhiteColors,
  },
};

const getColor = (key: string): string => getComputedStyle(document.documentElement).getPropertyValue(key);

/**
 * In design-system v11 theme color tokens are emitted as CSS variables by the
 * SCSS foundation and switched via the `dark`/`light` html class (see
 * `toggleHtmlClassName`). The v10 runtime `generateTheme` injection is gone, so
 * this returns an empty <style> element to keep the existing call contract.
 */
const changeThemeColors = () => document.createElement('style');

export { colors, getColor, changeThemeColors };
